export default "__VITE_ASSET__2ymk9W6L__"